<template>
  <div class="boss-table-title pega-print-title">
    <div class="pega-ta-right">
      <span data-test="company-name">{{ entryCompanyName }}
        <span
          v-if="userName"
          data-test="header-info"
        >
          <br>
          <span
            v-if="isDuplicatedEntries"
            class="boss-status-label pega-status-label pega-status-label-top-0"
            data-test="label-duplicated-entries"
          >重複応募
          </span>
          <span
            v-if="entryFormType"
            class="boss-status-label pega-status-label pega-status-label-top-0"
            data-test="label-entry-form"
          >{{ entryFormType }}
          </span>
          <span
            v-if="pathwayLabel"
            class="boss-status-label pega-status-label pega-status-label-top-0"
            data-test="label-pathway"
          >{{ pathwayLabel }}
          </span>
          <span data-test="user-name">応募者：{{ userName }}様</span>
        </span>
        <template v-if="updatedDate">
          <br><span data-test="updated-date">
            {{ updatedDate | parseDate }}現在
          </span>
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { directTypeLabel } from '@/lib/labelValueMappings'
import { createDate } from '@/lib/dateUtils.js'

export default {
  filters: {
    parseDate (val) {
      return createDate(val)?.format('YYYY年MM月DD日') ?? ''
    }
  },
  props: {
    entryCompanyName: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: ''
    },
    isDuplicatedEntries: {
      type: Boolean,
      default: false
    },
    entryFormType: {
      type: String,
      default: ''
    },
    pathway: {
      type: Number,
      default: null
    },
    updatedDate: {
      type: String,
      default: ''
    }
  },
  computed: {
    pathwayLabel () {
      return _.get(directTypeLabel, this.pathway, null)
    }
  }
}
</script>
